import { render, staticRenderFns } from "./CreateUser.vue?vue&type=template&id=b65b0544&scoped=true&lang=html&"
import script from "./CreateUser.vue?vue&type=script&lang=js&"
export * from "./CreateUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65b0544",
  null
  
)

export default component.exports